import { GestureResponderEvent } from 'react-native';

import { ChallengeHomeCardProps } from '@fhs/loyalty/src/components';
import { OrderDisplayType } from '@fhs/ui/src/components/order-display/types';

import { HomeAlertLaunchDarklyPayload } from './home-alert';

export type DisplayedOrder = {
  id: string;
  type: OrderDisplayType;
  storeName: string;
  serviceModeTitle: string;
  items: Array<{
    quantity: number;
    name: string;
    image: string;
  }>;
};

export type DoublePointsMondayBannerData = {
  isDoublePointsMondayOn: boolean;
  bannerImageUrl: string | null;
  onBannerPress?: () => void;
};

export type ScreenHomeProps = {
  //Boolean Values
  displayedOrderCardLoading?: boolean;
  isCateringEnabled: boolean;
  isDeliveryEnabled: boolean;
  isDesktop: boolean;
  isLoadingChallenges: boolean;
  loyaltyUserReady: boolean;
  reorderLoading?: boolean;
  shouldShowDelivery: boolean;
  //Homepage data
  alert: HomeAlertLaunchDarklyPayload | null;
  displayedOrder: DisplayedOrder;
  userPointExpireAlert: HomeAlertLaunchDarklyPayload | null;
  challengeHomeCardProps: ChallengeHomeCardProps | undefined;
  doublePointsMondayBanner?: DoublePointsMondayBannerData;
  //Routes
  careersPath: string;
  cateringRedirectPath: string;
  deliveryRedirectPath: string;
  donatePath: string;
  foundationPath: string;
  pickUpRedirectPath: string;
  redirectPath: string;
  //Actions
  onDeliverySelect: (event: GestureResponderEvent) => void;
  onReorder: () => void;
  logReorderCardPress: () => void;
  logPickUpOrderClickEvent: (event: GestureResponderEvent) => void;
  logDeliveryOrderClickEvent: (event: GestureResponderEvent) => void;
  logCateringOrderClickEvent: (event: GestureResponderEvent) => void;
};
